import { buildTailedFineArrowRing, } from "@plotlibre/geometry";
import { createRenderProperties, DEFAULT_ARROW_STYLE } from "./style.js";
export const TAILED_FINE_ARROW_TYPE = "arrow.fine.tailed";
export const tailedFineArrowDefinition = {
    type: TAILED_FINE_ARROW_TYPE,
    title: "Tailed Fine Arrow",
    category: "arrow",
    version: "1.0.0",
    controlSchema: {
        minPoints: 2,
        maxPoints: 2,
        completeOnDoubleClick: false,
        allowPointInsertion: false,
        allowPointRemoval: false,
    },
    defaultParameters: {
        tailWidthRatio: 0.055,
        headLengthRatio: 0.22,
        headWidthRatio: 1.9,
        neckWidthRatio: 0.42,
        minimumWidthMeters: 1,
        maximumWidthMeters: 100000,
        tailNotchRatio: 0.9,
    },
    defaultStyle: DEFAULT_ARROW_STYLE,
    generate({ feature }) {
        return generateTailedFineArrow(feature);
    },
};
export function generateTailedFineArrow(feature) {
    const [tail, tip] = feature.controlPoints;
    if (!tail || !tip) {
        throw new RangeError("Tailed fine arrow requires exactly two control points.");
    }
    const parameters = readParameters({
        ...tailedFineArrowDefinition.defaultParameters,
        ...feature.parameters,
    });
    const ring = buildTailedFineArrowRing(tail, tip, parameters);
    const geometry = {
        type: "Polygon",
        coordinates: [ring],
    };
    return {
        fills: [
            {
                type: "Feature",
                id: `${feature.id}:fill`,
                geometry,
                properties: createRenderProperties(feature, "fill", tailedFineArrowDefinition.defaultStyle),
            },
        ],
        lines: [
            {
                type: "Feature",
                id: `${feature.id}:outline`,
                geometry,
                properties: createRenderProperties(feature, "outline", tailedFineArrowDefinition.defaultStyle),
            },
        ],
        points: [],
        labels: [],
        hitAreas: [
            {
                type: "Feature",
                id: `${feature.id}:hit-area`,
                geometry,
                properties: createRenderProperties(feature, "hit-area", tailedFineArrowDefinition.defaultStyle),
            },
        ],
    };
}
function readParameters(parameters) {
    return {
        tailWidthRatio: readNumber(parameters, "tailWidthRatio"),
        headLengthRatio: readNumber(parameters, "headLengthRatio"),
        headWidthRatio: readNumber(parameters, "headWidthRatio"),
        neckWidthRatio: readNumber(parameters, "neckWidthRatio"),
        minimumWidthMeters: readNumber(parameters, "minimumWidthMeters"),
        maximumWidthMeters: readNumber(parameters, "maximumWidthMeters"),
        tailNotchRatio: readNumber(parameters, "tailNotchRatio"),
    };
}
function readNumber(parameters, key) {
    const value = parameters[key];
    if (typeof value !== "number" || !Number.isFinite(value)) {
        throw new TypeError(`Tailed fine arrow parameter "${key}" must be finite.`);
    }
    return value;
}
//# sourceMappingURL=tailed-fine-arrow.js.map